<template>
  <div class="container">
    Application content...
  </div>
</template>

<script>
export default {
  name: 'Home',
};
</script>
